import {
  Document,
  Page,
  Text,
  Image,
  View,
  StyleSheet,
  Font,
} from "@react-pdf/renderer";
import "./style.css";
import LogoImage from "assets/images/pdf/pdf-logo.png";
import { useProjectContext } from "@hooks/context/useProjectContext";

// Register font
Font.register({
  family: "Montserrat",
  src: "https://fonts.gstatic.com/s/montserrat/v25/JTUHjIg1_i6t8kCHKm4532VJOt5-QNFgpCtZ6Ew-Y3tcoqK5.ttf",
});

// Create styles
const styles = StyleSheet.create({
  view: {
    flexDirection: "row",
    margin: "20px 35px 0",
  },
  section: {
    flexGrow: 1,
    width: "50%",
  },
  info: {
    fontSize: 8,
    fontWeight: "light",
    margin: "10px 35px 0",
  },
  point: {
    fontSize: 9,
  },
  table: {
    fontSize: 8,
    margin: "25px 35px 15px",
    border: "1px solid grey",
  },
  row: {
    display: "flex",
    flexDirection: "row",
    borderTop: "1px solid #EEE",
    padding: 2,
  },
  header: {
    borderTop: "none",
    backgroundColor: "black",
    color: "white",
  },
  bold: {
    fontWeight: 900,
  },
  row1: {
    width: "35%",
    borderRight: "1px solid grey",
  },
  row2: {
    width: "17.25%",
    borderRight: "1px solid grey",
  },
  row3: {
    width: "17.25%",
    borderRight: "1px solid grey",
  },
  row4: {
    width: "17.25%",
    borderRight: "1px solid grey",
  },
  row5: {
    width: "17.25%",
  },
  headingOne: {
    fontWeight: 900,
    fontSize: "14px",
    width: "200px",
  },
  headingTwo: {
    fontSize: "18px",
    fontWeight: 900,
    textTransform: "uppercase",
    textAlign: "right",
  },
  pdfView: {
    width: "100%",
    height: "690px",
  },
  dataKey: {
    width: "100%",
    flexDirection: "row",
  },
  dataValue: {
    fontSize: "8px",
    padding: "2px",
    borderBottom: "1px solid grey",
    width: "50%",
  },
  projectKey: {
    width: "60%",
  },
  projectValue: {
    width: "40%",
  },
  textCenter: {
    textAlign: "center",
  },
  logo: {
    width: "100px",
    margin: "25px 35px 0",
  },
  width45: {
    width: "45%",
  },
  width15: {
    width: "15%",
  },
  width40: {
    width: "40%",
    alignItems: "flex-end",
  },
  width100: {
    width: "100px",
  },
  dataHeader: {
    backgroundColor: "black",
    color: "white",
    fontSize: "8px",
    padding: "2px",
  },
  green: {
    color: "green",
  },
  red: {
    color: "red",
  },
  chart: {
    flexDirection: "row",
    justifyContent: "space-around",
    margin: "0 25px",
  },
  margin15: {
    marginTop: "15px",
  },
});

export const PdfDocument = ({ dta }: { dta: string }) => {
  const { selectedProjectOrganisation } = useProjectContext();

  const data = [
    {
      reportingType: "Local Jobs First - Local Content (ANZ)",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
    {
      reportingType: "MPSG Hours Requirements(%)",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
    {
      reportingType: "Indigenous Business Spend($)",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
    {
      reportingType: "Opportinuty for Disadvantaged Victorians(Hrs)",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
    {
      reportingType: "Female Participation(Hrs)",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
    {
      reportingType: "Indigenous Participation(Hrs)",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
    {
      reportingType: "Femily Voience Leave Policy",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
    {
      reportingType: "Enviornment Substainability",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
    {
      reportingType: "Waste Diversion from landfill(%, $)",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
    {
      reportingType: "Reduce concreate embodied carbon emmisions",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
    {
      reportingType: "Minimise water consumption",
      agreed: "",
      value: "",
      progress: "",
      ager: "",
    },
  ];

  const projectDetails = [
    {
      key: "Project Start Date",
      value: "",
    },
    {
      key: "Project Finish Date",
      value: "",
    },
    {
      key: "Signed Contact Value",
      value: "",
    },
    {
      key: "Additional Variations",
      value: "",
    },
    {
      key: "Total Contract Value",
      value: "",
    },
    {
      key: "Progressive work hours to date",
      value: "",
    },
  ];

  const businessDetails = [
    {
      key: "Business Name",
      value: "Multiplex Constructions",
    },
    {
      key: "Representative",
      value: "John Smith",
    },
    {
      key: "Address",
      value: "500 Collins st, Meibiurnem 30000",
    },
    {
      key: "Email",
      value: "john@gmail.com",
    },
    {
      key: "Phone",
      value: "0400 000 0000",
    },
    {
      key: "ABN",
      value: "00 000 000 000",
    },
  ];

  const points = [
    {
      key: "Major Project Skills Garantee",
      value: "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    },
    {
      key: "Women's Equality and Safety",
      value: "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    },
    {
      key: "Opportinuty for Victorian Aboriginal People Employment",
      value: "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    },
    {
      key: "Aboriginal Business spend",
      value: "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    },
    {
      key: "Opportunity for Disadvantaged Victorians",
      value: "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    },
    {
      key: "Social Enterprise Activity",
      value: "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    },
    {
      key: "Sustainability Measures",
      value: "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    },
  ];

  const redPoints = {
    heading: "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    points: [
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    ],
  };

  const greenPoints = {
    heading: "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    points: [
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
      "Lorem ipsum dolor sit amet consectetur, adipisicing elit",
    ],
  };

  const header = "Social Procurement Report May 2023";
  const projectName = "Footscray Hospital Project";

  return (
    <Document>
      <Page size="A4">
        <View style={styles.logo}>
          <Image src={LogoImage} />
        </View>
        <View style={styles.view}>
          <View style={styles.section}>
            <Text style={styles.headingOne}>{header}</Text>
          </View>
          <View style={styles.logo}>
            <Image src={selectedProjectOrganisation.organisationLogo} />
          </View>
        </View>
        <View style={styles.view}>
          <View style={[styles.section, styles.width45]}>
            <Text style={styles.dataHeader}>{projectName}</Text>
            {projectDetails.map((row, i) => (
              <View key={i} style={styles.dataKey}>
                <Text style={[styles.dataValue, styles.projectKey]}>
                  {row.key}
                </Text>
                <Text style={[styles.dataValue, styles.projectValue]}>
                  {row.value}
                </Text>
              </View>
            ))}
          </View>
          <View style={styles.width15}></View>
          <View style={[styles.section, styles.width40]}>
            {businessDetails.map((row, i) => (
              <View key={i} style={styles.dataKey}>
                <Text style={styles.dataValue}>{row.key}</Text>
                <Text style={styles.dataValue}>{row.value}</Text>
              </View>
            ))}
          </View>
        </View>
        <View style={styles.table}>
          <View style={[styles.row, styles.bold, styles.header]}>
            <Text>Project Summary</Text>
          </View>
          <View style={[styles.row, styles.bold]}>
            <Text style={styles.row1}>Reporting Type</Text>
            <Text style={[styles.row2, styles.textCenter]}>Agreed %</Text>
            <Text style={[styles.row3, styles.textCenter]}>Value</Text>
            <Text style={[styles.row4, styles.textCenter]}>Progress</Text>
            <Text style={[styles.row5, styles.textCenter]}>%</Text>
          </View>
          <View style={styles.row}>
            <Text style={styles.row1}> </Text>
            <Text style={styles.row2}> </Text>
            <Text style={styles.row3}> </Text>
            <Text style={styles.row4}> </Text>
            <Text style={styles.row5}> </Text>
          </View>
          {data.map((row, i) => (
            <View key={i} style={styles.row} wrap={false}>
              <Text style={styles.row1}>{row.reportingType}</Text>
              <Text style={[styles.row2, styles.textCenter]}>{row.agreed}</Text>
              <Text style={[styles.row3, styles.textCenter]}>{row.value}</Text>
              <Text style={[styles.row4, styles.textCenter]}>
                {row.progress}
              </Text>
              <Text style={[styles.row5, styles.textCenter]}>{row.ager}</Text>
            </View>
          ))}
        </View>
        <View style={styles.chart}>
          <Image src={dta} style={styles.width100} />
          <Image src={dta} style={styles.width100} />
          <Image src={dta} style={styles.width100} />
        </View>
        <View style={[styles.chart, styles.margin15]}>
          <Image src={dta} style={styles.width100} />
          <Image src={dta} style={styles.width100} />
          <Image src={dta} style={styles.width100} />
        </View>
        <View style={styles.info}>
          <Text>
            Lorem ipsum dolor sit amet consectetur, adipisicing elit. Unde eum
            ex corrupti reiciendis distinctio doloremque in assumenda vero iure
            ducimus dolore, quam adipisci deserunt fuga aspernatur quis harum
            placeat dolor dolorum quaerat. Labore, tempore. Praesentium ipsam,
            quasi ullam nostrum quia culpa dolores itaque atque? Illum odit
            aliquid perferendis corporis impedit!
          </Text>
        </View>
        <View style={styles.info}>
          <Text style={[styles.point, styles.green]}>
            {greenPoints.heading}
          </Text>
          {greenPoints.points.map((row, i) => (
            <Text key={i}>
              <Text style={styles.point}>{i + 1}. </Text>
              {row}
            </Text>
          ))}
        </View>
        <View style={styles.info}>
          <Text style={[styles.point, styles.red]}>{redPoints.heading}</Text>
          {redPoints.points.map((row, i) => (
            <Text key={i}>
              <Text style={styles.point}>{i + 1}. </Text>
              {row}
            </Text>
          ))}
        </View>
        <View style={styles.info}>
          {points.map((row, i) => (
            <Text key={i}>
              <Text style={styles.point}>{row.key} - </Text>
              {row.value}
            </Text>
          ))}
        </View>
      </Page>
    </Document>
  );
};
